import Model from "../../classes/model/Model";
import User from "./User";

/**
 * @property {int} id
 * @property {int} is_delete
 * @property {int} old_id
 * @property {int} company_id
 * @property {int} capacity
 * @property {string} name
 * @property {string} content
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {User} creator
 * @property {User} updater
 */
export default class Room extends Model {

    relations() {
        return {
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

}
